// Contexts
import { useFetchErrorContextConsumerHook } from 'contexts/fetch-error.context';
import { useUploadIdContextConsumerHook } from 'containers/upload-id/contexts/upload-id.context';
// Types
import { UploadIdHookType } from './types/upload-id.hook.type';

const useUploadIdHook = (): UploadIdHookType => {
  const { uploadIdState } = useUploadIdContextConsumerHook(),
    { fetching: externalFetching, error } = useFetchErrorContextConsumerHook();

  return {
    error,
    externalFetching,
    uploadIdState,
  };
};

export { useUploadIdHook };
